export const numberFormaterString = (number: number) => {
    return new Intl.NumberFormat().format(number);
}